export default __webpack_public_path__ + "static/media/monica.7f151b20.png";